import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import Logo from "@/components/Logo";
import IntersectGrid from "@/components/IntersectMotif";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin");
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <section className="relative min-h-screen bg-obsidian flex items-center justify-center overflow-hidden">
      <IntersectGrid cols={6} rows={4} />
      <div className="relative z-10 w-full max-w-md px-6 text-center">
        <Logo width={200} className="mx-auto" />
        <p className="eyebrow mt-12 mb-4">Admin Access</p>
        <h1 className="text-3xl font-light tracking-tight text-ivory">Content Management</h1>
        <p className="mt-4 text-sm text-muted-text">Sign in with your authorized Intersect Holding account to manage site content and submissions.</p>
        <button onClick={login} className="btn-solid mt-10 w-full" data-testid="admin-google-login">
          <LogIn size={16} strokeWidth={1.5} /> Continue with Google
        </button>
        {user && !user.is_admin && (
          <p className="mt-6 text-sm text-destructive" data-testid="admin-denied">This account is not authorized for admin access.</p>
        )}
      </div>
    </section>
  );
}
